import { useState } from "react";

interface LimitCardProps {
  isDarkMode: boolean;
  setShowAuth: (val: boolean) => void;
  onClose?: () => void;
}

export const LimitCard = ({ isDarkMode, setShowAuth, onClose }: LimitCardProps) => {
  const [showCard, setShowCard] = useState(true);

  const handleSignIn = () => {
    setShowAuth(true);
    setShowCard(false);
    if (onClose) onClose();
  };

  if (!showCard) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Dark blurred overlay */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShowCard(false)}></div>

      {/* Card */}
      <div
        className={`relative flex flex-col items-center justify-between rounded-2xl shadow-2xl border overflow-hidden aspect-square w-full max-w-sm z-50 h-[400px]
          ${isDarkMode 
            ? 'bg-[#1c1c1c]/90 border-neutral-700 text-red-300' 
            : 'bg-white/90 border-neutral-200 text-red-700'}
        `}
      >
        

        {/* Image full width with padding */}
        <div className="w-full p-4">
          <img
            src="https://img.freepik.com/premium-vector/chat-bot-using-bubbles-woman-robot-virtual-assistance-website-mobile-applications-artificial-intelligence-messenger-support-concept_48369-22410.jpg"
            alt="Chatbot illustration"
            className="w-full select-none rounded-xl shadow-lg"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col items-center text-center px-4 pb-6">
          <h2 className="text-lg font-semibold">Daily Limit Reached</h2>
          <p className="text-sm mt-2">
            You've reached your daily limit of <span className="font-medium">5 free messages</span>.
          </p>

          <button
            onClick={handleSignIn}
            className="mt-4 px-5 py-2 text-sm font-medium rounded-full 
              bg-gradient-to-r from-purple-600 to-pink-500 text-white shadow-md 
              hover:opacity-90 transition"
          >
            Sign in for Unlimited Access
          </button>
        </div>
      </div>
    </div>
  );
};

export default LimitCard;
